import React, { Component } from 'react';
import PropTypes from 'prop-types';
import * as _ from 'lodash';

import FieldUtil from '../utils/FieldNames';

import '../../../../app/assets/stylesheets/rte_edit_payer.scss';
import { ErrorMessage } from 'formik';

class GroupMappingSection extends Component {
  renderSection() {
    return (
      <div>
        <ErrorMessage
          name="sections.group"
          render={msg => <div className="error">{msg}</div>}
        />
        <div className="group_mapping_section">
          <div className="fields">
            {FieldUtil.groupMappingFields.map((field, i) => (
              <div className="cost_rules" key={i}>
                <p><b>{FieldUtil.transformName(field)}</b></p>
              </div>
            ))}
          </div>
          <div className="field_values">
            {FieldUtil.groupMappingFields.map((field, i) => (
              <div className="cost_rules" key={i}>
                <p>{_.get(this.props.groupMappingData, [field]) || '---'}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }

  render() {
    return (
      <div>
        {this.renderSection()}
      </div>
    );
  }
}

GroupMappingSection.propTypes = {
  visibleSection:   PropTypes.string,
  groupMappingData: PropTypes.object
};

export default GroupMappingSection;
